import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthRedirectHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(
      window.location.search || window.location.hash.substring(1)
    );

    const type = params.get("type");

    if (type === "signup" || type === "email_change") {
      navigate(`/confirm-email?${params.toString()}`);
    } else if (type === "recovery") {
      navigate(`/reset-password?${params.toString()}`);
    } else {
      navigate("/home"); // ⬅️ Sends blank/no-type requests to /home
    }
  }, [navigate]);

  return <p style={{ color: "white", textAlign: "center" }}>Redirecting…</p>;
};

export default AuthRedirectHandler;
